import { ReactElement } from 'react';

import { PromiseVoidFunction } from '@dreryk/react-common';
import { Modal, ModalWidth } from '@dreryk/react-components';

import { prescriptionsTranslationKeys } from '../../../../../translations';

import { ProAuctoreAndProFamiliaMissingContactDetailsForm } from './ProAuctoreAndProFamiliaMissingContactDetailsForm/ProAuctoreAndProFamiliaMissingContactDetailsForm';
import { ProAuctoreAndProFamiliaMissingDoctorContactDetails } from './ProAuctoreAndProFamiliaMissingContactDetailsModal.types';
import { ProAuctoreAndProFamiliaMissingContactDetailsModalConfirmButton } from './ProAuctoreAndProFamiliaMissingContactDetailsModalConfirmButton';
import { ProAuctoreAndProFamiliaModalExitButtons } from './ProAuctoreAndProFamiliaModalExitButtons';

type ProAuctoreAndProFamiliaMissingDetailsModalProps = {
   readonly missingDetails: ProAuctoreAndProFamiliaMissingDoctorContactDetails;
   readonly onMissingDetailsUpdated: PromiseVoidFunction;
   readonly onClose: VoidFunction;
};

export const ProAuctoreAndProFamiliaMissingContactDetailsModal = (
   props: ProAuctoreAndProFamiliaMissingDetailsModalProps
): ReactElement => {
   return (
      <Modal
         testId={'recipientCategoryMissingContactDetailsModal'}
         width={
            Array.isArray(props.missingDetails) || props.missingDetails === 'address'
               ? ModalWidth.WIDE
               : ModalWidth.NORMAL
         }
         title={prescriptionsTranslationKeys.missingAddressForPAPF.missingAddressDetails}
      >
         <ProAuctoreAndProFamiliaMissingContactDetailsForm missingDetails={props.missingDetails}>
            {({ handleSubmit, formState }) => (
               <>
                  <ProAuctoreAndProFamiliaMissingContactDetailsModalConfirmButton
                     handleSubmit={handleSubmit}
                     missingDetails={props.missingDetails}
                     onMissingDetailsUpdated={props.onMissingDetailsUpdated}
                     onClose={props.onClose}
                  />
                  <ProAuctoreAndProFamiliaModalExitButtons onClose={props.onClose} formState={formState} />
               </>
            )}
         </ProAuctoreAndProFamiliaMissingContactDetailsForm>
      </Modal>
   );
};
